import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Send, MessageSquare } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export const AdminMessaging = ({ candidateId }) => {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");

  const load = useCallback(() => {
    if (!candidateId) return;
    api.get(`/candidates/${candidateId}/messages`).then(({ data }) => setMessages(data)).catch(() => {});
  }, [candidateId]);
  useEffect(() => { load(); }, [load]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const { data } = await api.post(`/candidates/${candidateId}/messages`, { text });
      setMessages((m) => [...m, data]);
      setText("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="admin-messaging">
      <p className="text-neutral-500 text-xs uppercase tracking-[0.15em] mb-3 flex items-center gap-2">
        <MessageSquare size={14} /> Messagerie
      </p>
      <div className="space-y-2 max-h-48 overflow-y-auto custom-scroll mb-3 pr-1">
        {messages.length === 0 && <p className="text-xs text-neutral-600 italic">Aucun message.</p>}
        {messages.map((m) => (
          <div key={m.id} data-testid={`admin-msg-${m.id}`} className={`max-w-[85%] p-2.5 text-sm ${m.sender === "admin" ? "ml-auto bg-theatre-red/20 border border-theatre-red/30" : "bg-white/5 border border-white/10"}`}>
            <p className="text-[10px] uppercase tracking-[0.15em] text-neutral-500 mb-1">{m.sender === "admin" ? "Vous (Viva Artist)" : "Candidat"}</p>
            <p className="text-neutral-200">{m.text}</p>
          </div>
        ))}
      </div>
      <form onSubmit={send} className="flex gap-2">
        <Input data-testid="admin-msg-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Répondre…" className="bg-black/50 border-white/15 text-white rounded-none h-10 focus-visible:ring-theatre-gold" />
        <button type="submit" data-testid="admin-msg-send" className="bg-theatre-red hover:bg-theatre-redhover text-white px-4 transition-colors duration-200 flex items-center"><Send size={15} /></button>
      </form>
    </div>
  );
};
